// Dependency imports
import { Stack } from '@mui/material';
import { useState } from 'react';

// Local imports
import { Button, Typography } from 'components';
import { TextInput } from 'components/Form';
import { useAddCameraData } from 'api/sdk';
import { useSnack } from 'plugins/snack';

interface AddCameraProps {
  url: string;
  setUrl: any;
  name: string;
  setName: any;
  setOpenModel: any;
  refetch: () => void;
}

const AddCamera = ({
  url,
  setUrl,
  name,
  setName,
  setOpenModel,
  refetch
}: AddCameraProps) => {
  const [error, setError] = useState<string | null>(null);
  const { mutateAsync: addCameras, isLoading: loadingAdd } = useAddCameraData();
  const snack = useSnack();

  const validateForm = () => {
    setError(null);

    if (name.trim().length === 0) {
      setError('Camera name is required!');
      return;
    }

    if (name.trim().length < 5) {
      setError('Camera Name must be at least 5 characters long');
      return;
    }

    if (name.trim().length > 20) {
      setError("Camera Name can't be more than 20 characters");
      return;
    }

    if (!name.match(/^[a-zA-Z][a-zA-Z0-9_-]*$/)) {
      setError(
        'Camera name must start with a letter and can only contain letters, numbers, hyphens, and underscores'
      );
      return;
    }

    if (url.trim().length === 0) {
      setError('RTSP url cannot be empty');
      return;
    }

    if (
      !url.match(
        /^rtsp:\/\/(?:[a-zA-Z0-9_-]+\:[a-zA-Z0-9_-]+@)?[a-zA-Z0-9.-]+(?::\d+)?\/?.*$/
      )
    ) {
      setError('Wrong rtsp url format. Ex format: rtsp://example.com/stream');
      return;
    }

    if (error === null) {
      addCameraToConfig();
    }
  };

  const addCameraToConfig = async () => {
    await addCameras({
      data: {
        name: name,
        url: url
      }
    })
      .then((res: any) => {
        snack({
          message: res?.data?.message,
          severity: 'success'
        });
        setName('');
        setUrl('');
        setError(null);
        setOpenModel(false);
        refetch();
      })
      .catch(error => {
        console.log(error);
        snack({
          message: error?.response?.data?.detail,
          severity: 'error'
        });
      });
  };

  return (
    <div>
      <Stack direction="row" width={'100%'}>
        <Typography style={{ fontSize: '16px' }}>Add Camera</Typography>
      </Stack>
      <Stack spacing={2} alignContent={'center'} marginTop="20px">
        <TextInput
          label="Camera Name"
          name="name"
          variant="outlined"
          size="small"
          value={name}
          onChange={value => setName(value)}
        />
        <TextInput
          label="Camera URL"
          name="url"
          variant="outlined"
          size="small"
          value={url}
          onChange={value => setUrl(value)}
        />
        <p style={{ color: 'red', fontSize: 12, fontWeight: 'bold' }}>
          {error}
        </p>
      </Stack>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        spacing={4}
        marginTop={'20px'}
      >
        <Button onClick={validateForm}>Add</Button>
        <Button variant="outlined" onClick={() => setOpenModel(false)}>
          Cancel
        </Button>
      </Stack>
    </div>
  );
};

export default AddCamera;
